<div class="">
	<div class="row">
		<div class="col-lg-6 offset-lg-3">
			<div *ngIf="errormessage" class="message-bad">{{errormessage}}</div>
			<div class="item-panel">
				<div class="heading">Disable MFA</div>
				<div class="content">
					<p>To disable Multi-Factor Authentication (MFA), you need to enter the code generated by your authenticator app.</p>
					<p>Enter the code below to confirm the action:</p>
					<form>
						<div class="form-group">
							<label for="mfa_code">MFA Code</label>
							<input [(ngModel)]="mfa_code" name="mfa_code" type="text" class="form-control">
						</div>
						<div class="form-group">
							<app-action-button [action]="DisableMFA" [context]="this" processing="Disabling..." complete="MFA Disabled">Disable MFA</app-action-button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>